module.exports = __webpack_public_path__ + "static/media/pin-pin-pinterest-icon-svgrepo-com.910f7d8a.svg";